import axios from 'axios';
type payloadCreate = {
  amount: number;
  note: string;
}[];
export const createPricing = async (payload: payloadCreate, fileId: number) => {
  const { data: res } = await axios.post(`/files/${fileId}/pricing`, { pricings: payload });
  return res;
};
export const deletePricing = async (pricingId: number) => {
  const { data: res } = await axios.delete(`/files/pricing/${pricingId}`);
  return res;
};

export const createFileDocument = async (
  payload: { fileDocumentsIds: number[] },
  fileId: number
) => {
  const { data: res } = await axios.put(`/admin/files/${fileId}/documents`, payload);
  return res;
};
type payloadCreateReminder = {
  date: string;
  note: string;
  showBailiff?: boolean;
  showAdmin?: boolean;
};
export const createReminder = async (payload: payloadCreateReminder, fileId: number) => {
  const { data: res } = await axios.post(`/files/${fileId}/reminders`, payload);
  return res;
};
export const deleteReminder = async (reminderId: number) => {
  const { data: res } = await axios.delete(`/files/reminders/${reminderId}`);
  return res;
};
